export default __webpack_public_path__ + "static/media/gallery_09.3727b9c7.jpg";